import React from "react";
import "./styles.css";
import { SocialIcon } from "react-social-icons";

export default function Footer() {
  return (
    <div className="Footer">
      <div className="FooterIcons">
        <SocialIcon
          url="https://github.com/esiebomaj"
        className="FooterIcon"
      />
      <SocialIcon
        url="https://www.linkedin.com/in/jeremiahesieboma/"
        className="FooterIcon"
      />
      <SocialIcon
        url="https://www.instagram.com/esiebomaj"
        className="FooterIcon"
        />
      </div>
      <div className="FooterText">
        <p>
          Made with ❤️ by <a href="https://aboutjeremiah.tech" target="_blank" rel="noopener noreferrer">JeremAIh</a>
        </p>
      </div>
    </div>
  );
}
